import { createAction } from '@reduxjs/toolkit';
import { HOTEL_HOVERED } from './constants';
import type { ActiveHotelState } from '../map/types';
import { name } from './slice';
import type { IHotel } from './types';

export const hotelHoverAction = createAction<ActiveHotelState>(HOTEL_HOVERED);

export const showMoreAction = createAction(`${name}/showMore`);

export const paginationSuccessAction = createAction<{ resultHotels: IHotel[] }>(
  `${name}/paginationSuccess`,
);

export const setCurrentVisibleHotelsAction = createAction<number[]>(
  `${name}/setCurrentVisibleHotels`,
);
